"use strict";
function identity(x) {
    return x;
}
exports.identity = identity;
//# sourceMappingURL=identity.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/util/identity.js
// module id = 219
// module chunks = 7